<template>
  <v-container v-resize="onResize" style="padding: 0px; max-width: 100%">
    <DashboardComponent
      mod="cul"
      :grid.sync="layout"
      :updated.sync="layoutUpdate"
      :comps="comps"
      :size="size"
      :height="height"
    />
  </v-container>
</template>
<script>
import ApexColumn from "@/../../coreui/library/ApexColumn";
// import ApexDonut from '@/../../coreui/library/ApexDonut'
import ApexDonut from "@/../../coreui/library/ApexDonut";
import ApexStacked from "@/../../coreui/library/ApexStacked";
import TimelineChart from "@/../../coreui/library/TimelineChart";
import DashboardComponent from "@/../../coreui/library/DashboardComponent";
import axiosInstances from "@/../../coreui/server/axiosInstances";
import TextItem from "@/../../coreui/library/TextGridItem";
import helper from "./helper";
import ui from "@/../../coreui/helpers/ui";
import utils from "@/../../coreui/helpers/utils";
import { sync } from "vuex-pathify";

export default {
  components: {
    DashboardComponent,
    // ApexDonut
    // Gauge,
    // ApexTest,
    // ApexPie
  },
  data: () => ({
    strains: { fvalues: null, vvalues: null, xvalues: null, dvalues: null },
    lastheight: 40,
    height: 40,
    windowSize: {
      x: 0,
      y: 0,
    },
    harvests: { labels: [], values: [] },
    strains: { labels: [], values: [] },
    trims: { labels: [], values: [] },
    plantings: { labels: [], values: [] },
		totalPlants: 0,
		totalStrains: 0,
		totalPlantings: 0,
		totalFlowering: 0,
		totalVegetative: 0,
		totalDead: 0,
    stateValues: {},
    plantedDates: [],
    growPhase: [],
    strainCount: [],
    labels: [],
    values: [],
    debouncer: true,
    layoutUpdate: false,
    layout: [
      {
        x: 0,
        y: 0,
        w: 2,
        h: 1,
        i: 0,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 2,
        y: 0,
        w: 2,
        h: 1,
        i: 1,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 4,
        y: 0,
        w: 2,
        h: 1,
        i: 2,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 6,
        y: 0,
        w: 2,
        h: 1,
        i: 3,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 8,
        y: 0,
        w: 2,
        h: 1,
        i: 4,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      {
        x: 10,
        y: 0,
        w: 2,
        h: 1,
        i: 5,
        static: true,
        isDraggable: false,
        isResizable: false,
      },
      { x: 0, y: 2, w: 12, h: 6, i: 6 },
      { x: 4, y: 2, w: 12, h: 6, i: 7 },
      // { x: 8, y: 2, w: 4, h: 6, i: 8 },
      // { x: 0, y: 7, w: 6, h: 6, i: 9 },
      // { x: 6, y: 7, w: 6, h: 6, i: 10 },
    ],
    size: 7,
  }),

  computed: {
    width() {
      this.windowSize.x / 12;
    },
    // theme: sync('theme'),
    // themeMenu: sync('themeMenu'),
    facility: sync("login/facility"),
    mqttTableUpdated: sync("mqtt/mqttTableUpdated"),
    comps() {
      return [
        {
          args: {
            s: 0,
            label: "Live Plants",
            value: this.totalPlants
						// this.harvests.totalWeight
            //   ? this.harvests.totalWeight.toFixed(2) +
            //     " " +
            //     this.harvests.weightUnit
            //   : "",
          },
          component: TextItem,
        },
        {
          args: {
            s: 1,
            label: "Immature Plants",
            value: this.totalPlantings,
          },
          component: TextItem,
        },
        {
          args: {
            s: 2,
            label: "Number of Strains",
            value: this.strains.labels.length,
          },
          component: TextItem,
        },
        {
          args: {
            s: 3,
            label: "Vegetative Plants",
            value: this.totalVegetative
              // (this.trims.totalFlowerWeight
              //   ? this.trims.totalFlowerWeight.toFixed(2)
              //   : "0") +
              // " " +
              // (this.harvests.weightUnit ? this.harvests.weightUnit : ""), //' lb',
          },
          component: TextItem,
        },
        {
          args: {
            s: 4,
            label: "Flowering Plants",
            value: this.totalFlowering
              // (this.trims.totalSmallsWeight
              //   ? this.trims.totalSmallsWeight.toFixed(2)
              //   : "0") +
              // " " +
              // (this.harvests.weightUnit ? this.harvests.weightUnit : ""), //|| 0 +' lb'
          },
          component: TextItem,
        },
        {
          args: {
            s: 5,
            label: "Dead Plants",
            value: this.totalDead
              // (this.trims.totalTrimWeight
              //   ? this.trims.totalTrimWeight.toFixed(2)
              //   : "0") +
              // " " +
              // (this.harvests.weightUnit ? this.harvests.weightUnit : ""), //|| 0+' lb'
          },
          component: TextItem,
        },
        {
          args: {
            name: "widget 1",
            values: [
              {
                name: "Flowering",
                data: this.strains.fvalues ? this.strains.fvalues : [44, 55],
              },
              {
                name: "Vegetative",
                data: this.strains.vvalues ? this.strains.vvalues : [44, 55],
              },
              {
                name: "Dead",
                data: this.strains.dvalues ? this.strains.dvalues : [44, 55],
              },
              {
                name: "Destroyed",
                data: this.strains.xvalues ? this.strains.xvalues : [44, 55],
              },
            ],
            stacked: true,
            labels: this.strains.labels,
            title: "Plants by Strain",
            subtitle: "Active Plants",
            fullscreen: true,
            s: 6,
            height: this.height,
            width: this.width,
            loading: false,
						// palette: 'palette7',
            palette_light: "palette9",
            palette_dark: "palette7",
          },
          component: ApexColumn, // ApexPie //PieChart
        },
        {
          args: {
            stacked: true,
            name: "widget 2",
            values: [
              {
                name: "Live",
                data: this.plantings.live ? this.plantings.live : [],
              },
              {
                name: "Dead",
                data: this.plantings.dead ? this.plantings.dead : [],
              },
            ],
            labels: this.plantings.labels,
            title: "Plantings",
            subtitle: "Live/Dead Count",
            fullscreen: true,
            s: 7,
            height: this.height,
            width: this.width,
            // 'colorize': true,
            annotate: false,
            loading: false,
						// palette: 'palette6'
            palette_light: "palette8",
            palette_dark: "palette3",
          },
          component: ApexColumn,
        },
      ];
    },
  },
  watch: {
    async facility(val, old) {
      if (val == old) {
        return;
      }
      await this.getData();
    },
    mqttTableUpdated: {
      async handler(val) {
        this.elog("debug", "mqtt callback for updating table: {}", val)();
        if (
          val == "cul_harvest" ||
          val == "cul_process" ||
          val == "cul_trim" ||
          val == "cul_palntings"
        ) {
          await this.getData();
        }
        this.mqttTableUpdated = "";
      },
    },
    layout: {
      deep: true,
      handler: function (newVal, oldVal) {
        // console.log('in cultivation: layout updated', newVal)
      },
    },
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      if (this.windowSize.y != this.lastheight) {
        this.height = this.windowSize.y;
        this.lastheight = this.height;
      }
    },
    getCurTime() {
      let d = new Date(Date.now());
      return d;
    },

    async getData() {
			this.totalPlants = 0
			this.totalStrains = 0
			this.totalPlantings = 0
			this.totalFlowering = 0
			this.totalVegetative = 0
			this.totalDead = 0
      for (let i = 0; i < this.layout.size; i++) {
        this.comps[i].args.loading = true;
      }
      let strains = await helper.getStrains();
      let plantings = await helper.getPlantings();

			// sort these multi-arrays
			let tempList = []
			this.totalPlants = 0
			for (let i=0; i<strains.fvalues.length; i++) {
				tempList.push({f : strains.fvalues[i], v: strains.vvalues[i], d: strains.dvalues[i], x: strains.xvalues[i], l: strains.labels[i]})
				this.totalPlants += strains.fvalues[i]
				this.totalPlants += strains.vvalues[i]
				this.totalFlowering += strains.fvalues[i]
				this.totalVegetative += strains.vvalues[i]
				this.totalDead += strains.dvalues[i]
			}
			
			tempList.sort(function(a,b)  {
				let atotal = a.f + a.v + a.x + a.d 
				let btotal = b.f + b.v + b.x + b.d 
				if (atotal < btotal) {return 1} else {return -1}
				return 0
			})
			let fv = [], vv = [], xv = [], dv = [], ll = []
			for (let i=0; i<tempList.length; i++) {
				dv.push(tempList[i].d)
				fv.push(tempList[i].f)
				vv.push(tempList[i].v)
				xv.push(tempList[i].x)
				ll.push(tempList[i].l)
			}
      
			let numPlantings = 0
			let gp = [], pl = [], pd = [], pa = []
			console.log('plantings: ', plantings)
			if (plantings.live != undefined) {
				for (let j=0; j< plantings.live.length; j++) {
					numPlantings += plantings.live[j]
					let val = {l: plantings.labels[j], a: plantings.live[j], d: plantings.dead[j]}
					gp.push(val)
				}
				gp.sort(function(a,b)  {
					if (a.a < b.a) {return 1} else {return -1}
					return 0
				})
				
				for (let i=0; i<gp.length; i++) {
					pl.push(gp[i].l)
					pd.push(gp[i].d)
					pa.push(gp[i].a)
				}
				this.totalPlantings = numPlantings
			}
      this.plantings ={labels: pl, live: pa, dead: pd}
			this.strains = {fvalues: fv, vvalues: vv, dvalues: dv, xvalues: xv, labels: ll}
      for (let i = 6; i < this.layout.size; i++) {
        this.comps[i].args.loading = false
      }
      this.elog(
        "trace",
        "Dashboard Data - harvests {}, strains {}, trims {}, plantings {}",
        this.harvests,
        this.strains,
        this.trims,
        this.plantings
      )();
    },
  },

  async mounted() {
    await this.getData();
    let self = this;
  },

  beforeDestroy() {
    // this.themeMenu = false
  },
};
</script>

